import {notNull} from '../../../../../../library/clxProductNet/assets/js/modules/common/assert';

export default class UiCalculator {
    private _headerElement: HTMLElement;
    private _mainElement: HTMLElement;
    private _accountAreaGrid: HTMLDivElement | null = null;
    private _accountNavContainer: HTMLDivElement | null;
    private _accountNavigationAccountContainer: HTMLDivElement | null;

    constructor() {
        this._headerElement = notNull(document.querySelector('#header')) as HTMLElement;
        this._mainElement = notNull(document.querySelector('#main')) as HTMLElement;

        this._accountAreaGrid = document.querySelector<HTMLDivElement>('.account_area');
        this._accountNavContainer = document.querySelector<HTMLDivElement>('.account_nav_container');
        this._accountNavigationAccountContainer = document.querySelector<HTMLDivElement>('.account_navigation > .account');

        this._scrollIntoView();
        this._initResizeListener();
        this._observeNotificationClose();
        this._setDynamicContentPartsHeight();
    }

    _initResizeListener() {
        window.addEventListener('resize', () => {
            this._setDynamicContentPartsHeight();
        });

        window.addEventListener('visibilitychange', () => {
            this._setDynamicContentPartsHeight();
        });
    }

    _scrollIntoView() {
        const activeItem: HTMLLIElement | null = document.querySelector('.account_nav_container ul > li.active');
        if (activeItem instanceof HTMLLIElement) {
            this._setDynamicContentPartsHeight();
            activeItem.scrollIntoView({block: 'nearest'});
        }
    }

    _observeNotificationClose() {
        const navigationCloseButtons = document.querySelectorAll('.mod_notification_bar .close-overlay');

        navigationCloseButtons.forEach((navigationCloseButton) => {
            if (navigationCloseButton !== null) {
                navigationCloseButton.addEventListener('click', () => {
                    this._setDynamicContentPartsHeight();
                });
            }
        });
    }

    _setDynamicContentPartsHeight() {
        const totalHeaderHeight = this._headerElement.offsetHeight;
        const contentHeight = window.innerHeight - totalHeaderHeight;

        // Align main-element under navigation.
        this._mainElement.style.marginTop = totalHeaderHeight.toString() + 'px';

        if (this._accountAreaGrid instanceof HTMLDivElement) {
            this._accountAreaGrid.style.height = contentHeight.toString() + 'px';
        }

        if (this._accountNavContainer instanceof HTMLDivElement && this._accountNavigationAccountContainer instanceof HTMLDivElement) {
            // Nav container height
            this._accountNavContainer.style.height = (contentHeight - 60 - this._accountNavigationAccountContainer.offsetHeight).toString() + 'px';
        }

        // On mobile devices we have to adjust the content container also
        if (window.innerWidth < 1024) {
            const contentContainer = document.querySelector<HTMLDivElement>('.account_area .area-content');

            if (contentContainer instanceof HTMLDivElement) {
                contentContainer.style.height = contentHeight.toString() + 'px';
                contentContainer.style.top = totalHeaderHeight.toString() + 'px';
            }
        }
    }
}
